import fetchModels from "../../mixin/store/api/fetchModels";
import pushModel from "../../mixin/store/api/pushModel";

export default {
    actions: {
        fetchOfficialCurrencyRates(context, date) {
            if (context.state.officialCurrencyRates.isNeedFetch) {
                return fetchModels(context, 'currency_rates?order[id]=desc&createdAt[after]=' + date + '&exists[company]=false',
                    1, 'updateOfficialCurrencyRates')
            }
        },
        fetchCompanyCurrencyRates(context, data) {
            if (context.state.companyCurrencyRates.isNeedFetch) {
                return fetchModels(context, 'currency_rates?order[id]=desc&createdAt[after]=' + data.dateTime + '&exists[company]=true&company=' + data.id,
                    null, 'updateCompanyCurrencyRates')
            }
        },
        pushCompanyCurrencyRate(context, data) {
            return pushModel(context, 'currency_rates', data)
        },
    },
    mutations: {
        updateOfficialCurrencyRates(state, data) {
            state.officialCurrencyRates = data
            state.companyCurrencyRates.isNeedFetch = false
        },
        updateCompanyCurrencyRates(state, data) {
            state.companyCurrencyRates = data
            state.companyCurrencyRates.isNeedFetch = false
        },
    },
    state: {
        officialCurrencyRates: {
            models: [],
            totalItems: 0,
            isNeedFetch: true
        },
        companyCurrencyRates: {
            models: [],
            totalItems: 0,
            isNeedFetch: true
        },
    },
    getters: {
        getOfficialCurrencyRateByShortName: (state, getters) => (shortName, baseShortName) => {
            return getters.getOfficialCurrencyRates.find(model => model.currency.shortName === shortName && model.baseCurrency.shortName === baseShortName)
        },
        getCompanyCurrencyRateByShortName: (state, getters) => (shortName, baseShortName) => {
            return getters.getCompanyCurrencyRates.find(model => model.currency.shortName === shortName && model.baseCurrency.shortName === baseShortName)
        },
        getOfficialCurrencyRates(state) {
            return state.officialCurrencyRates.models
        },
        getCompanyCurrencyRates(state) {
            return state.companyCurrencyRates.models
        },
    },
}
